import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogProps,
    InternalStandardProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { AppButton } from "../AppButton";

const StyledDialog = styled(Dialog)(() => ({}));

export interface RedirectionDialogProps
    extends InternalStandardProps<DialogProps> {
    onClose: () => void;
    open: boolean;
    dialogMessage?: string;
}

export const RedirectionDialog = (props: RedirectionDialogProps) => {
    const { className, onClose, dialogMessage, open } = props;

    return (
        <Box className="App" style={{ textAlign: "center" }}>
            <StyledDialog
                data-testid="consent-redirection-dialog"
                role="dialog"
                aria-modal="true"
                maxWidth={"sm"}
                fullWidth
                className={className}
                open={open}
            >
                <DialogContent>
                    <DialogContentText>{dialogMessage}</DialogContentText>
                </DialogContent>

                <DialogActions
                    style={{
                        display: "flex",
                    }}
                >
                    <AppButton
                        role="button"
                        buttonVariant="primary-filled"
                        onClick={onClose}
                    >
                        Next
                    </AppButton>
                </DialogActions>
            </StyledDialog>
        </Box>
    );
};
